export default __webpack_public_path__ + "static/media/logo-3d-ovato-coin-perspective-new.86e01e4e.jpg";